import { render, staticRenderFns } from "./ShiftsView.vue?vue&type=template&id=f12a3118&scoped=true&"
import script from "./ShiftsView.vue?vue&type=script&lang=js&"
export * from "./ShiftsView.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsView.vue?vue&type=style&index=0&id=f12a3118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12a3118",
  null
  
)

export default component.exports